/* eslint-disable */
import React, { Component } from 'react';

import {
  ActuarialExamList,
  CFAExamList,
  FRMExamList,
  GMATExamList,
  ROLES,
  examNameAccordingToDB,
  examNames,
  examObject,
} from '../../common/constant';
import { updateSelectedExam } from './service';
import AppRoutes from '../../views/config/AppRoutes';
import userStore from "../../store/userStore";

class ExamDropdownMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Initialize your state here
      examName: examNames[localStorage.getItem('selectedmenu')] || '',
      menu_class: 'menu_hide',
      selectedExamMenu: '',
      userRole: 'user',
    };
  }

  toggleMenu = () => {
    // Implement the toggle function here
    this.setState((prevState) => ({
      menu_class: prevState.menu_class === 'menu_hide' ? 'menu_show exam_menu' : 'menu_hide',
    }));
  };

  openExamsMenu = (menu) => {
    // Implement the menu opening function here
    this.setState((prevState) => ({
      selectedExamMenu: prevState.selectedExamMenu === menu ? '' : menu,
    }));
  };

  selectedMenu = async (value) => {
    // Implement the menu selection function here
    localStorage.setItem('selectedmenu', value);
    const data = {
      exam_selected: value,
      organizationDomain: localStorage.getItem('organizationDomain'),
      role: localStorage.getItem('role'),
    };

    await updateSelectedExam(data);
    await userStore.fetchProfile();
    this.setState({
      examName: examNames[localStorage.getItem('selectedmenu')] || '',
      menu_class: 'menu_hide',
    });
    await userStore.getUserWebinarsCount();
    const targetDashboard =
      value === examNameAccordingToDB.FRM && localStorage.getItem('role') === ROLES.EMPLOYEE
        ? AppRoutes.FRM_V2_DASHBOARD
        : examObject[value].sidebarRoutes.dashboard;
    // Force a full document reload (not a soft react-router push) so every dashboard widget —
    // progress bars, "My Reports", "Saved Items / Flashcards" tabs — refetches for the newly
    // selected exam. Exams that share the same route (e.g. CFA L1 2025/2026/2027 all map to
    // /cfa1/2026/dashboard) would otherwise NOT remount on a soft push, leaving widgets showing
    // the previous year's data until a manual hard reload. This mirrors the cross-exam-level
    // switch behaviour the user already gets a fresh page from.
    window.location.href = targetDashboard;
  };

  render() {
    const { examName, menu_class } = this.state;
    console.log("examName: ", examName)
    return (
      <li className='nav-item drop_down_parent exam_dropdown_menu'>
        <a
          onClick={this.toggleMenu}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleMenu();
            }
          }}
          className='nav-link white-color-text text-overflow-header'
          role='button'
          tabIndex={0}
          aria-haspopup='true'
          aria-expanded={menu_class !== 'menu_hide'}
          aria-label={`Select exam, current: ${examName || 'none selected'}`}
        >
          <span className='white-color-text' id='examName'>
            {examName || 'Select Exam'}
          </span>
          <i className='fa fa-angle-down' aria-hidden='true' />
        </a>
        <ul className={menu_class} id='menu_state'>
          {this.renderExamSubMenu('CFA Exams', CFAExamList())}
          {this.renderExamSubMenu('FRM Exams', FRMExamList)}
          {this.renderExamSubMenu('Actuarial Exams', ActuarialExamList)}
          {this.renderExamSubMenu('MBA Admission', GMATExamList)}
        </ul>
      </li>
    );
  }

  renderExamSubMenu(title, exams) {
    const { selectedExamMenu } = this.state;
    const { userRole } = this.props;
    const handleToggleKey = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.openExamsMenu(title);
      }
    };
    return (
      <li>
        <span
          className={`exam-submenu-toggle ${selectedExamMenu === title && 'open'}`}
          id={title}
          role='button'
          tabIndex={0}
          aria-expanded={selectedExamMenu === title}
          onClick={() => this.openExamsMenu(title)}
          onKeyDown={handleToggleKey}
        >
          {title} <i className='fa fa-angle-right' aria-hidden='true' />
        </span>
        <ul className={`exam-submenu-dropdown ${selectedExamMenu === title && 'open'}`}>
          {exams.map(
            (exam) =>
              (!exam.role || userRole === exam.role) && (
                <li key={exam.value}>
                  <a
                    className={`pointer_class ${
                      localStorage.getItem('selectedmenu') === exam.value && 'active'
                    }`}
                    // value={exam.value}
                    id={exam.label}
                    role='button'
                    tabIndex={0}
                    onClick={() => this.selectedMenu(exam.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.selectedMenu(exam.value);
                      }
                    }}
                  >
                    {exam.label}
                  </a>
                </li>
              ),
          )}
        </ul>
      </li>
    );
  }
}

export default ExamDropdownMenu;



// WEBPACK FOOTER //
// ./src/components/Header/ExamDropdownMenu.jsx